
import { Component } from '@angular/core';
import { ModalService } from 'app/common/services/modal.service';
import { IngrediantService } from 'app/services/ingrediant.service';
import { TranslateService } from '@ngx-translate/core';
import { ReceiptEditorComponent } from './recipe-editor.component';
import { iconDownload, iconSave, iconStore, iconTrash } from 'app/common/utils/icons.utils';

@Component({
	selector: 'receipt-editor-2-column',
	templateUrl: './recipe-editor-2-column.component.html',
	styleUrls: ['../receipt-creation.component.scss']
})
export class ReceiptEditor2ColumnComponent extends ReceiptEditorComponent {
	iconTrash = iconTrash;
	iconDownload = iconDownload;
	iconSave = iconStore;
	
	constructor(
		_modalService: ModalService,
		_ingrediantService: IngrediantService,
		_translateService: TranslateService
	) {
		super(_modalService, _ingrediantService, _translateService);
	}


}